<template>
    <v-container fill-height h100foot id="details">
        <v-layout column>
            <v-flex :class="{'display-2 my-5': $vuetify.breakpoint.mdAndUp,'display-1 mt-5': $vuetify.breakpoint.smAndDown}" text-xs-center>Why {{this.$myApp.customer.name}}</v-flex>
            <v-flex>
                <div class="headline mt-3">Quality and Professionalism</div>
                <p :class="{'mt-3':$vuetify.breakpoint,'subheading': $vuetify.breakpoint.mdAndUp,'body-1': $vuetify.breakpoint.smAndDown}">
                    With over 25 years of experience in the flooring industry {{this.$myApp.customer.name}} can help guide you through the flooring process from design through to completion.
                    Our quality is uncomprimised with a level of professionalism that will leave a smile on your face.
                </p>
            </v-flex>
            <v-flex>
                <div class="headline mt-3">What areas do we service</div>
                <p :class="{'mt-3':$vuetify.breakpoint,'subheading': $vuetify.breakpoint.mdAndUp,'body-1': $vuetify.breakpoint.smAndDown}">
                    From Auckland through to the far north, no matter where you live we can accomodate your next flooring project.
                </p>
            </v-flex>
            <div class="text-xs-center">
                <v-btn fab class="mt-5 brown darken-4">
                    <scrollactive class="my-nav">
                        <a href="#services" class="none scrollactive-item"><v-icon large color="white">fas fa-angle-down</v-icon></a>
                    </scrollactive>
                </v-btn>
            </div>
        </v-layout>
    </v-container>
</template>

<script>
export default {
    name: 'HomeDetails'
};
</script>

<style scoped>

</style>
